import React from 'react';
import PropTypes from 'prop-types';

import { Stepper as MUIStepper } from '@material-ui/core';

export const Stepper = props => <MUIStepper {...props} />;

Stepper.propTypes = {
  activeStep: PropTypes.number,
  alternativeLabel: PropTypes.bool,
  classes: PropTypes.object,
  connector: PropTypes.node,
  nonLinear: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};

export default Stepper;
